import * as stylex from '@stylexjs/stylex';
import type { CellRendererValueProps } from '../cellRenderer.types';

export type TextListProps = CellRendererValueProps<readonly string[]> & {
  truncateText?: boolean;
};

/** Displays a text list as centered, comma-separated cell content. */
export const TextList = ({ value, truncateText = false }: TextListProps) => (
  <div {...stylex.props(styles.root, truncateText && styles.truncatedText)}>{value?.join(', ')}</div>
);

const styles = stylex.create({
  root: { textAlign: 'center' },
  truncatedText: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
});
